/*
 * @Description:
 */
import { createApp, Directive } from 'vue'
import App from './App.vue'
// import './pwa/registerServiceWorker'
import router from './router'
import { store, useStore } from './store'
import { loadAllPlugins } from './plugins'
import '@/assets/iconfont/iconfont.css'
import '@/styles/index.scss'
import 'normalize.css'
import * as directives from '@/directives'
import '@/permission'

const app = createApp(App)
// 加载所有插件
loadAllPlugins(app)

// 自定义指令
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string ]: Directive })[key])
})

app.mixin({
  methods: {
    $hasPermission: (needPermissions: string[]) => {
      const permissions = useStore().state.user.permission
      if (needPermissions && needPermissions instanceof Array && needPermissions.length > 0) {
        return permissions.some((p: any) => {
          return needPermissions.includes(p)
        })
      }
      return false
    }
  }
})

app.use(store).use(router).mount('#app')
